<template>
  <div class="expert-manage" id="expert-manage">
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>
    <section class="expert-box">
      <el-breadcrumb
        separator-class="el-icon-arrow-right "
        class="breadcrumb myMain"
      >
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="search-box">
        <el-input
          v-model="keyword"
          prefix-icon="el-icon-search"
          placeholder="请搜索专家"
          @change="getExpertList"
        ></el-input>
      </div>
      <div class="content myMain">
        <h2>专家</h2>
        <div class="expert-list">
          <template>
          <!--
            <ul
              class="infinite-list"
              v-infinite-scroll="load"
              infinite-scroll-disabled="disabled"
              style="height: 498px"
            >-->
            <ul class="expert-ul">
              <li
                v-for="(item, index) in expertData"
                class="expert-list-item"
                :key="index"
                @click="gotoDetail(item)"
              >
                <h4>{{ getName(item.name) }}</h4>
                 <p>性别：{{ item.sex == 1 ? "男" : "女" }}</p>
                <p class="id-number" v-if="item.idcode">
                  身份证号：<span class="number">{{getId(item.idcode) }}</span>
                </p>
                
                <p v-if="item.title && item.title > 1">职称：{{ getTitle(item.title) }}</p>
                <p v-if="item.refereeLevel > 1">裁判级别：{{ getRefereeLevel(item.refereeLevel) }}</p>
               
                 <p v-if = "getLocaltion(item)">常驻地：{{ getLocaltion(item) }}</p>
              </li>
            </ul>
            <!--
            <p v-if="loading" class="loading">加载中...</p>
            <p v-if="noMore" class="noMore">没有更多了</p>-->
          </template>
        </div>
        <div class="pagination">
          共{{ total }}条
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="params.pageSize"
            :pager-count="5"
            background
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </section>
    <footer-cmp></footer-cmp>
  </div>
</template>

<script>
import headerCmp from "../components/common/header.vue";
import menuCmp from "../components/common/navMenu.vue";
import footerCmp from "../components/common/footer.vue";

import { getExpertList } from "@/api/home/index";
export default {
  data() {
    return {
      // loading: false,
      count: 10,
      keyword: null,
      expertData: null,
      params: {
        pageIndex: 1,
        pageSize: 10,
      },
      total: 0,
    };
  },
  components: {
    headerCmp,
    menuCmp,
    footerCmp,
  },
  // computed: {
  //   // noMore() {
  //   //   return this.total < 10;
  //   // },
  //   disabled() {
  //     return this.loading || this.noMore;
  //   },
  // },
  created() {
    this.getExpertList();
  },
  methods: {
    handleCurrentChange(v) {
      this.params.pageIndex = v;
      this.getExpertList();
    },
    // load() {
    //   console.log("cfl");
      // this.loading = true;
      // this.params.pageIndex++;
    //   this.getExpertList();
    // },
    getName(name) {
      return name.slice(0,name.length - 1) + "*";
    },
    getRefereeLevel(level){
      if(level == 1){
        return null;
      }
      if(level == 2){
        return "田径国家级裁判";
      }
      if(level == 3){
        return "田径国际级裁判";
      }
    },

    getId(id){
      return id.slice(0, id.length-4) + "****";
    },
    getExpertList() {
      const _this = this;
      getExpertList({kw:this.keyword, ...this.params}).then((res) => {
        _this.expertData = res.data.list;
        _this.total = res.data.total;
      });
    },
    getTitle(value){
      if(value > 0 && value < 4){
      var text = [null,"教授","副教授","高级工程师"];
      return text[value];
      }else{
        return null;
      }
    },
    gotoDetail(item){
      //this.$router.push('/expert/expertDetail?id=' + item.id);
    },

    getLocaltion(item){
      var location = null;
      if(item.province){
        location = item.province;
        if(item.city){
          location += ' ' + item.city;
        }
      }
      return location;
     
    }
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.expert-manage {
  font-size: 14px;
  .expert-box {
    overflow: hidden;
    margin-bottom: 64px;
    .search-box {
      width: 100%;
      padding: 15px 0;
      background-color: #f5f5f5;
      display: flex;
      justify-content: center;
      margin: 20px 0;
      .el-input {
        width: 300px;
        height: 45px;
        ::v-deep input {
          height: 100%;
        }
      }
    }
    .content {
      h2 {
        font-size: 28px;
        font-weight: normal;
        margin-bottom: 30px;
      }
      .expert-list {
        .expert-ul {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          width: 100%;
          .expert-list-item {
            width: 49%;
            border-radius: 8px;
            border: 1px solid #f1f1f1;
            margin-top: 15px;
            padding: 16px 26px 16px 26px;
            line-height: 25px;
            box-sizing: border-box;
            color: #99999a;
            font-size: 16px;
          //  flex-wrap: wrap;    
          //  display: flex;
          //  justify-content: space-between;
          // p{
          //  width: 49%;
          // }
            span.number {
              color: #da5351;
            }
            h4 {
              font-size: 20px;
              line-height: 35px;
              color: #333;
              width: 100%;
            }
            .id-number {
            }
          }
        }
        .noMore,
        .loading {
          margin-top: 12px;
          display: flex;
          justify-content: center;
          margin-top: 0.04rem;
        }
      }
    }
  }
  //搜索框样式
  ::v-deep .el-input__inner {
    text-align: center;
  }
  ::v-deep .el-input__prefix {
    left: 94px;
    top: 2%;
  }
}
@media screen and (max-width: 960px) {
  #expert-manage {
    padding-top: 0.56rem;
    .breadcrumb {
      display: none;
    }
    .search-box {
      margin: 0;
      padding: 0.12rem 0;
      .el-input {
        width: 2.45rem;
        height: 0.36rem;
      }
    }
    .content {
      padding: 0.16rem;
      width: auto;
      h2 {
        font-size: 0.18rem;
        color: #333333;
        line-height: 0.24rem;
        font-weight: 500;
        color: #333333;
        margin: 0;
        padding-bottom: 0.12rem;
        border-bottom: 1px solid #f1f1f1;
        display: block;
      }
      .expert-list {
        ul {
          height: 100% !important;
          // overflow: hidden;
          .expert-list-item {
            margin: 0;
            padding: 0;
            font-size: 0.12rem;
            line-height: 0.18rem;
            width: 100%;
            border: 0;
            border-bottom: 1px solid #f1f1f1;
            border-radius: 0;
            padding: 0.12rem 0;
            h4 {
              font-size: 0.14rem;
              font-weight: 500;
              color: #454545;
              line-height: 0.2rem;
            }
            // p:nth-child(2n){
            //   width: 47%;
            // }
            // p:nth-child(2n+1){
            //   width: 52%;
            // }
            // p:last-child{
            //   width: 100%;
            // }
            .id-number {
            //  margin: 0.06rem 0 0.04rem 0;
            }
          }
        }
      }
      .noMore,
      .loading {
        display: flex;
        justify-content: center;
        margin-top: 0.04rem;
      }
    }
    .footer {
      display: none;
    }
    ::v-deep .el-input--prefix .el-input__inner{
      font-size: .14rem;
    }
    ::v-deep .el-input__prefix {
      left: .7rem;
      font-size: .14rem;
      top: 0;
      .el-input__icon{
        line-height: .36rem;
      }
    }
  }
}
</style>
